import script from "./EcommerceCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceCategory.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceCategory.vue?vue&type=style&index=0&id=6a26924a&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a26924a"]])

export default __exports__